<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader.vue";
import Detay from "./bayi_tahsilat_detay.vue"

export default {
  page: {
    title: "Bayi Tahsilatlari (Personel)",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Detay
  },
  data() {
    return { 
        list: {},
        title: "BAYİ TAHSİLATLARI (PERSONEL)",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "BAYİ TAHSİLATLARI (PERSONEL)",
            active: true,
          },
        ],
        openId:[],
        total:0,
        isLoading: true,
        form:{},
        rows: [],
        detayData:{}
    };
  },
   mounted() {
    this.date()
    this.loadItems()
  },
  methods: {
    date(){
        var currentDate = new Date();
        var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        this.form.startdate= this.formatDate(firstDay),
        this.form.startdateend= this.formatDate(lastDay)
    },

    formatDate(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1; // JavaScript'te aylar 0'dan başlar, bu yüzden +1 ekliyoruz
        var year = date.getFullYear();

        // Gerekirse, gün ve ayı iki haneli yapmak için sıfır ekleyebilirsiniz
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        
        return year + '-' + month + '-' + day;
    },
  
    loadItems() {
      this.isLoading = true
      this.$http.post("/dealers/tahsilatlar?group=manager", this.form)
            .then(response => {
                this.rows= response.data
               
                let total = 0;
                for (let key in response.data) {
                    if (response.data.hasOwnProperty(key)) {
                        total += parseFloat(response.data[key].total);
                    }
                }
                this.total =  total
                this.isLoading = false
            })
    },

    formSubmit() {
      this.loadItems()
    },

    detay(props){
      this.odemeAlDetay = props
      this.$parent.$bvModal.show('odeme_al')
    },

    toggle(id){
      let indeks = this.openId.indexOf(id);

      if (indeks !== -1) {
        this.openId.splice(indeks, 1);
      }else{
        this.openId.push(id)
      }
    },

    detail(props, bayidata){
      this.detayData = { odemeTuru:props.type , ...bayidata, ...this.form, groupname:'manager' } 
      this.$parent.$bvModal.show('detay_modal')
    },

    clear(){
      this.form.startdate ='' 
      this.form.startdateend= ''
      this.loadItems()
    },
    filter(val){
      if(val.target.value.length < 3) return
      
      this.loadItems()
    }
  },
};
</script>

<template>
  <Layout>
    <Detay :data="detayData" />
    <PageHeader :title="title" :items="items" />
    <div class="row mb-3">
     <Transition name="fade">
        <div class="offset-lg-6 col-lg-6">
          <div class="card1">
            <div class="card-body1">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                    <div class="col-xl-8">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <label class="d-flex justify-content-between">Tarih Aralığı
                                <span 
                                    v-if="form.startdate || form.startdateend" 
                                    class="text-danger" 
                                    @click="clear()">
                                    Temizle
                                  </span>
                                </label>
                                <div class="input-group">
                                <input type="date" class="form-control"  v-model="form.startdate">
                                <button style="border:0;background: transparent;">  - </button>
                                <input type="date" class="form-control"  v-model="form.startdateend">
                                </div>
                            </div>
                        </div>
                    </div>
                  <div class="col-xl-4">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <label>-</label>
                        <div class="button-items">
                            <button 
                              type="submit"
                              class="btn btn-primary w-100 "   
                              >
                              Sorgula
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-1">
          <div class="card-body">
            <input type="text" class="form-control" placeholder="En az 3 karakter giriniz!" v-model="form.query" @keyup="filter($event)">
          </div>
        </div>
      </div>
    </div>
    <div class="row">     
      <Loader :loading="true" :load="isLoading">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                  <table class="table table-hover">
                  <thead>
                      <tr>
                        <th style="width:50%">Tahsilat Yapılan</th>
                        <th>Tarih Aralığındaki Tahsilat<br/>({{form.startdate}} - {{ form.startdateend }})</th>
                        <th style="width:50px"></th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-if="rows.length == 0">
                        <td colspan="3" class="text-center">Kayıt Bulunamadı</td>
                      </tr>
                      <template v-for="(row,i) in rows">
                        <tr :key="i">
                            <td>{{ row.name }}</td>
                            <td>{{ $paraFormat(row.total) }}</td>
                            <td style="width:50px">
                              <i 
                              @click="toggle(i)" 
                              class="bx" 
                              :class="[openId.includes(i) ? 'bxs-up-arrow': '','bxs-down-arrow' ]"></i>
                            </td>
                        </tr>
                        <tr :key="`${i}-t`" v-if="openId.includes(i)">
                          <td></td>
                          <td colspan="2">
                              <table class="table">
                                <tbody>
                                  <tr v-for="(r,idx) in row.islemler" :key="`c${idx}`">
                                    <td>{{ r.title }}</td>
                                    <td class="text-end">{{ $paraFormat(r.total) }}</td>
                                    <td class="text-end">
                                      <button class="btn btn-outline-info btn-sm" @click="detail(r,row)">
                                        <i class="bx bx-search-alt-2"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                        </tr>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th></th>
                        <th>{{ $paraFormat(total) }}</th>
                        <th></th>
                      </tr>
                    </tfoot>
                  </table>    
                </div>    
              </div>    
            </div>    
        </div>
      </Loader>
    </div>
  </Layout>
</template>